import React, { useCallback } from "react";
import styled, { withTheme } from "styled-components";
import FilterChannelList from "./controlComponents/FilterChannelList";
import EventsList from "./controlComponents/EventsList";
import { useNavigate } from "react-router-dom";
// import inRange from "lodash/inRange";
import Button from "common/Button";
import SavedSection from "./controlComponents/SavedSection";
import FavouriteCompanies from "./controlComponents/FavouriteCompanies";
import RoutePlanning from "./controlComponents/RoutePlanning";
import { useSetSearchQuery } from "utils/useQuery";

import CompanySearch from "controls/controlComponents/CompanySearch";
import {
  PowerSettingsNew,
  FilterList,
  List,
  Star,
  Search,
  Map,
  LocationOn,
} from "@material-ui/icons";

const BREAKPOINT = "850px";

const ControlBarHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  left: 0px;
  top: 0px;
  z-index: 2;
  width: calc(100% - 30px);
  position: absolute;
  @media (max-width: ${BREAKPOINT}) {
    padding: 0;
    width: 100%;
  }
`;
const HolderBlock = styled.div`
  position: relative;
`;
const MainControls = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: ${BREAKPOINT}) {
    width: 100vw;
    ${HolderBlock} {
      width: 100%;
    }
    button {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0;
      border-radius: 0;
      border-right: 1px solid #eaeaea;
    }
    button > svg {
      margin: 0 !important;
    }
    button > span {
      display: none;
    }
  }
`;

function ControlBar({
  toggleModal,
  setSelectedCompany,
  setToggleModal,
  setSelectedRoute,
  selectedRoute,
  channels,
  selectedChannels,
  filteredEvents,
  toggleChannel,

  checkedOnlyFavs,
  setCheckedOnlyFavs,
  savedLocation,
  reloadSavedLocation,

  query,
  setUpdateEvents,
  updateEvents,
  isLoading,
  isLoadingEvents,
  theme,
}) {
  const navigate = useNavigate();
  const { setSearchQuery } = useSetSearchQuery();

  const logOut = useCallback(() => {
    navigate({ pathname: "/login", search: "?q=1" });
    localStorage.removeItem("token");
  }, [navigate]);

  return (
    <ControlBarHolder>
      <MainControls>
        <HolderBlock>
          <Button
            title="Ereignisfilter"
            color={theme.interactionColor}
            background={theme.whiteBackground}
            Icon={FilterList}
            iconColor={theme.black100}
            iconMargin="0 5px 0 0"
            iconSize="20px"
            margin="0 15px 0 0"
            text="Ereignisfilter"
            onClick={() => setToggleModal(1)}
            tabIndex={1}
          />
          {toggleModal === 1 && (
            <FilterChannelList
              checkedOnlyFavs={checkedOnlyFavs}
              setCheckedOnlyFavs={setCheckedOnlyFavs}
              selectedChannels={selectedChannels}
              channels={channels}
              toggleChannel={toggleChannel}
              isLoading={isLoading}
            />
          )}
        </HolderBlock>
        <HolderBlock>
          <Button
            title="Ereignisse"
            margin="0 15px 0 0"
            iconColor={theme.black100}
            color={theme.interactionColor}
            iconMargin="0 5px 0 0"
            iconSize="20px"
            Icon={List}
            background={theme.whiteBackground}
            text="Ereignisse"
            onClick={() => setToggleModal(2)}
            tabIndex={2}
          />
          {toggleModal === 2 && (
            <EventsList
              setToggleModal={setToggleModal}
              toggleModal={toggleModal}
              channels={channels}
              filteredEvents={filteredEvents}
              setUpdateEvents={setUpdateEvents}
              updateEvents={updateEvents}
              isLoadingEvents={isLoadingEvents}
            />
          )}
        </HolderBlock>
        <HolderBlock>
          <Button
            title="Firmenfavoriten"
            onClick={() => setToggleModal(3)}
            margin="0 15px 0 0"
            iconColor={theme.black100}
            color={theme.interactionColor}
            background={theme.whiteBackground}
            Icon={Star}
            iconMargin="0 5px 0 0"
            iconSize="20px"
            text="Firmenfavoriten"
            tabIndex={3}
          />
          {toggleModal === 3 && (
            <FavouriteCompanies
              setSelectedCompany={setSelectedCompany}
              toggleModal={toggleModal}
              isLoading={isLoading}
              setToggleModal={setToggleModal}
            />
          )}
        </HolderBlock>
        <HolderBlock>
          <Button
            title="Firmensuche"
            margin="0 15px 0 0"
            color={theme.interactionColor}
            iconColor={theme.black100}
            background={theme.whiteBackground}
            Icon={Search}
            iconMargin="0 5px 0 0"
            iconSize="20px"
            text="Firmensuche"
            onClick={() => setToggleModal(4)}
            tabIndex={4}
          />
        </HolderBlock>
        {toggleModal === 4 && (
          <CompanySearch
            setSelectedCompany={setSelectedCompany}
            setSelectedRoute={setSelectedRoute}
            setToggleModal={setToggleModal}
            selectedRoute={selectedRoute}
            toggleModal={toggleModal}
          />
        )}
        <HolderBlock>
          <Button
            title="Standardregion"
            margin="0 15px 0 0"
            iconColor={savedLocation?.start_lat ? theme.whiteBackground : theme.black100}
            color={savedLocation?.start_lat ? theme.whiteBackground : theme.interactionColor}
            background={savedLocation?.start_lat ? theme.interactionColor : theme.whiteBackground}
            iconMargin="0 5px 0 0"
            hoverBackground={
              savedLocation?.start_lat ? theme.interactionColorDark : theme.hoverColorGray
            }
            iconSize="20px"
            text="Standardregion"
            Icon={Map}
            onClick={() => setToggleModal(5)}
            tabIndex={5}
          />
          {toggleModal === 5 && (
            <SavedSection
              selectedChannels={selectedChannels}
              query={query}
              setToggleModal={setToggleModal}
              toggleModal={toggleModal}
              isSaved={savedLocation?.start_lat}
              reloadSavedLocation={reloadSavedLocation}
            />
          )}
        </HolderBlock>
        <HolderBlock>
          <Button
            title="Routenplanung"
            onClick={() => {
              // setSearchQuery({ fromCompanySearch: null });
              setToggleModal(6);
            }}
            margin="0 15px 0 0"
            color={theme.interactionColor}
            iconColor={theme.black100}
            background={theme.whiteBackground}
            Icon={LocationOn}
            iconMargin="0 5px 0 0"
            iconSize="20px"
            text="Routenplanung"
            tabIndex={6}
          />
          {toggleModal === 6 && (
            <RoutePlanning
              setSelectedCompany={setSelectedCompany}
              toggleModal={toggleModal}
              isLoading={isLoading}
              setToggleModal={setToggleModal}
              setSelectedRoute={setSelectedRoute}
              selectedRoute={selectedRoute}
            />
          )}
        </HolderBlock>
        <HolderBlock>
          <Button
            title="Log out"
            color={theme.interactionColor}
            background={theme.whiteBackground}
            Icon={PowerSettingsNew}
            iconMargin="0"
            iconSize="20px"
            onClick={logOut}
            padding="0.7rem"
            tabIndex={7}
          />
        </HolderBlock>
      </MainControls>
    </ControlBarHolder>
  );
}

export default withTheme(ControlBar);
